var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("provisionBatch.details.title")) +
              ": " +
              _vm._s(_vm.batch.batchId) +
              " "
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { color: "primary", small: "", disabled: !_vm.summary },
              on: {
                click: function($event) {
                  _vm.reportDialogOpen = true
                }
              }
            },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-file-document-outline")
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("provisionBatch.details.reportDialog.generateReport")
                  ) +
                  " "
              )
            ],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _vm.summary
        ? _c("provision-batch-report-dialog", {
            attrs: { batch: _vm.batch, summary: _vm.summary },
            model: {
              value: _vm.reportDialogOpen,
              callback: function($$v) {
                _vm.reportDialogOpen = $$v
              },
              expression: "reportDialogOpen"
            }
          })
        : _vm._e(),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("h3", { staticClass: "mb-3" }, [
                    _vm._v(
                      _vm._s(_vm.$t("provisionBatch.details.batchInformation"))
                    )
                  ]),
                  _c("v-simple-table", [
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("provisionBatch.details.tenant"))
                            )
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.tenantId))])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("provisionBatch.details.started"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.formatDateTime(_vm.batch.startedAt))
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("provisionBatch.details.completed"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.batch.completedAt
                                ? _vm.formatDateTime(_vm.batch.completedAt)
                                : _vm.$t("provisionBatch.details.inProgress")
                            )
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("provisionBatch.details.duration"))
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatDuration(_vm.batch.durationSeconds)
                            )
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("provisionBatch.details.status"))
                            )
                          ])
                        ]),
                        _c(
                          "td",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: _vm.getStatusColor(_vm.batch),
                                  small: ""
                                }
                              },
                              [_vm._v(_vm._s(_vm.batch.currentStatus))]
                            )
                          ],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("provisionBatch.details.totalEvents")
                              )
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.batch.totalEventsCount.toLocaleString())
                          )
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "provisionBatch.details.purchaseInvoices"
                                )
                              )
                            )
                          ])
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.batch.purchaseInvoicesCount))
                        ])
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("provisionBatch.details.salesInvoices")
                              )
                            )
                          ])
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.batch.salesInvoicesCount))])
                      ])
                    ])
                  ]),
                  !_vm.batch.success && _vm.batch.errorMessage
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { type: "error", text: "", dense: "" }
                        },
                        [_vm._v(_vm._s(_vm.batch.errorMessage))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("h3", { staticClass: "mb-3" }, [
                    _vm._v(
                      _vm._s(_vm.$t("provisionBatch.details.statusHistory"))
                    )
                  ]),
                  _c(
                    "v-timeline",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.batch.statusHistory, function(entry, index) {
                      return _c(
                        "v-timeline-item",
                        {
                          key: index,
                          attrs: {
                            small: "",
                            color: _vm.getHistoryStatusColor(entry.status)
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "opposite",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatTime(entry.timestamp)
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("div", [
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(entry.status))
                            ]),
                            entry.count
                              ? _c("div", { staticClass: "text-caption" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("provisionBatch.details.count")
                                    ) +
                                      ": " +
                                      _vm._s(entry.count)
                                  )
                                ])
                              : _vm._e(),
                            entry.message
                              ? _c("div", { staticClass: "text-caption" }, [
                                  _vm._v(_vm._s(entry.message))
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.summary
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("h3", { staticClass: "mb-3" }, [
                        _vm._v(
                          _vm._s(_vm.$t("provisionBatch.details.areaSummary"))
                        )
                      ]),
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.summaryHeaders,
                          items: _vm.summary.areaSummaries,
                          "hide-default-footer": "",
                          "show-expand": "",
                          "single-expand": "",
                          expanded: _vm.expandedRows
                        },
                        on: {
                          "update:expanded": function($event) {
                            _vm.expandedRows = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item.totalAcceptedCostGross",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.totalAcceptedCostGross
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.totalReimbursementNet",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.totalReimbursementNet
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.baseProvisionNet",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.baseProvisionNet
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.transactionProvisionNet",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.transactionProvisionNet
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.sourceProvisionNet",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.sourceProvisionNet
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.totalPurchaseInvoiceAmount",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.totalPurchaseInvoiceAmount
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.totalSalesInvoiceAmount",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.totalSalesInvoiceAmount
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "item.netToTaxiCompany",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          item.netToTaxiCompany
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            },
                            {
                              key: "expanded-item",
                              fn: function(ref) {
                                var headers = ref.headers
                                var item = ref.item
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "pa-4",
                                      attrs: { colspan: headers.length }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          item.monthlyBreakdown &&
                                          item.monthlyBreakdown.length > 0
                                            ? _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "provisionBatch.details.monthlyBreakdown"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-simple-table",
                                                    { attrs: { dense: "" } },
                                                    [
                                                      _c("thead", [
                                                        _c("tr", [
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "provisionBatch.details.month"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "th",
                                                            {
                                                              staticClass:
                                                                "text-right"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "provisionBatch.details.amount"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      ]),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          item.monthlyBreakdown,
                                                          function(month) {
                                                            return _c(
                                                              "tr",
                                                              {
                                                                key:
                                                                  month.monthName
                                                              },
                                                              [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-right"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        month.monthName
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-right"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        month.eventCount.toLocaleString()
                                                                      ) + " kpl"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _c("tfoot", [
                                                        _c(
                                                          "tr",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold"
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "provisionBatch.details.total"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.eventCount.toLocaleString()
                                                                  ) + " kpl"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          item.provisionConfigurations &&
                                          item.provisionConfigurations.length >
                                            0
                                            ? _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    md:
                                                      item.monthlyBreakdown &&
                                                      item.monthlyBreakdown
                                                        .length > 0
                                                        ? 6
                                                        : 12
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "provisionBatch.details.provisionConfiguration"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-list",
                                                    { attrs: { dense: "" } },
                                                    _vm._l(
                                                      item.provisionConfigurations,
                                                      function(config, index) {
                                                        return _c(
                                                          "v-list-item",
                                                          {
                                                            key: index,
                                                            staticClass: "px-0"
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          config.provisionType
                                                                        ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          _vm.formatPercentage(
                                                                            config.percentage
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          config.description
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "provisionBatch.details.calculationBase"
                                                                          )
                                                                        ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          config.calculationBase
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          (!item.monthlyBreakdown ||
                                            item.monthlyBreakdown.length ===
                                              0) &&
                                          (!item.provisionConfigurations ||
                                            item.provisionConfigurations
                                              .length === 0)
                                            ? _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-alert",
                                                    {
                                                      attrs: {
                                                        type: "info",
                                                        text: "",
                                                        dense: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "provisionBatch.details.noDataAvailable"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "body.append",
                              fn: function() {
                                return [
                                  _c(
                                    "tr",
                                    {
                                      staticClass:
                                        "font-weight-bold grey lighten-4"
                                    },
                                    [
                                      _c("td"),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "provisionBatch.details.total"
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(_vm._s(_vm.computedTotalEvents))
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalAcceptedCostGross
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalReimbursementNet
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalBaseProvision
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalTransactionProvision
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalSourceProvision
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalPurchaseInvoiceAmount
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .totalSalesInvoiceAmount
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatCurrency(
                                              _vm.summary.totals
                                                .netToTaxiCompany
                                            )
                                          )
                                        )
                                      ]),
                                      _c("td"),
                                      _c("td")
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          41472942
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.batch.jsonSummaryFileName ||
          _vm.batch.eventIdsFileName ||
          _vm.batch.detailedReportFileName
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("h3", { staticClass: "mb-3" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("provisionBatch.details.downloadReports")
                          )
                        )
                      ]),
                      _vm.batch.jsonSummaryFileName
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadFile(
                                    _vm.batch.jsonSummaryFileName
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-download")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("provisionBatch.details.jsonSummary")
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.batch.eventIdsFileName
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadFile(
                                    _vm.batch.eventIdsFileName
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-download")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("provisionBatch.details.eventIds")
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.batch.detailedReportFileName
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadFile(
                                    _vm.batch.detailedReportFileName
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-download")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "provisionBatch.details.detailedJson"
                                    )
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }